import { DesignData } from 'editor/src/store/design/types';

const designContainsText = (designData: DesignData) =>
  !!designData.spreads.find((spread) => spread.pages[0].groups.media?.find((element) => element.type === 'text'));

export default designContainsText;
